import React, { useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
//import { Link } from 'react-admin'

import { orange } from '../../constants/colorConstants'

const useStyles = makeStyles((theme) => ({
  file: {
    whiteSpace: 'nowrap',
    color: orange,
  },
  textUnderlined: {
    verticalAlign: 'text-top',
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto500Normal,
    textDecoration: 'underline',
  },
  text: {
    verticalAlign: 'text-top',
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto500Normal,
  },
  link: {
    color: orange,
    '&:link': {
      color: orange,
    },
    '&:visited': {
      color: orange,
    },
  },
}))

export const ViewInvoiceField = ({
  sourceInvoiceNumber,
  sourceInvoiceId,
  sourcePaymentId,
  sourceAmount,
  record,
  label,
  headerClassName,
  linkDataInvoices,
  mode,
  handleClick,
  emptyMessage,
  ...props
}) => {
  const classes = useStyles()
  const [shouldLink, setShouldLink] = useState(false)
  const [url, setUrl] = useState(undefined)

  const invoiceNumber = record[sourceInvoiceNumber]
  const invoiceId = record[sourceInvoiceId]
  const paymentId = record[sourcePaymentId]
  const amount = record[sourceAmount]

  useEffect(() => {
    if (
      (linkDataInvoices &&
        invoiceId &&
        paymentId &&
        amount &&
        mode !== 'selectInvoice') ||
      (linkDataInvoices && invoiceId && mode === 'selectInvoice')
    ) {
      const currentLinkData = linkDataInvoices[invoiceId]
      if (!currentLinkData) return setShouldLink(false)
      if (currentLinkData.status === 'found') {
        const page = Math.floor(currentLinkData.index / 10) + 1
        const tabName = currentLinkData.tabName
        if (mode === 'selectInvoice') {
          setUrl(
            `/invoices?filter=%7B%22tabName%22%3A%22${tabName}%22%7D&page=${page}&perPage=10&selectedItemId=${invoiceId}&expandedId=${invoiceId}&mode=${mode}`
          )
        } else {
          setUrl(
            `/invoices?filter=%7B%22tabName%22%3A%22${tabName}%22%7D&page=${page}&perPage=10&selectedItemId=${paymentId}&expandedId=${invoiceId}&selectedAmount=${amount}&mode=${mode}`
          )
        }
      }
      if (currentLinkData.status === 'not found') {
        setUrl(undefined)
      }
    }
  }, [linkDataInvoices, amount, invoiceId, mode, paymentId])

  useEffect(() => {
    if (shouldLink && url) {
      setShouldLink(false)
      window.location.href = url
    }
    return () => {
      setShouldLink(false)
    }
  }, [shouldLink, url])

  // const handleInternalClick = () => {
  //   if (url) setShouldLink(true)
  //   if (handleClick) handleClick(record)
  // }

  return (
    <Typography
      variant="body2"
      className={classes.file}
      label={label}
      headerClassName={headerClassName}
      {...props}
    >
      {url && (
        // <Link to={url} onClick={handleInternalClick} className={classes.link}>
        <span className={classes.textUnderlined}>{invoiceNumber}</span>
        // </Link>
      )}
      {!url && invoiceNumber && (
        <span className={classes.text}>{invoiceNumber}</span>
      )}
      {!url && !invoiceNumber && emptyMessage && (
        <span className={classes.text}>{emptyMessage}</span>
      )}
    </Typography>
  )
}
